import { useState } from 'react';

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import Typescript from '@mui/material/Typography'

import Title from '../../components/Title'
import Text from '../../components/Text'

import icon_1 from '../../images/image.png'

import image from '../../images/symptoms/confronto.png'

function Phytoplasma() {

  return (

    <Container className="border-t-2 border-slate-950 border-dotted bgwhite">

      <Grid container flexDirection="row" className="px-0">

        <Grid container size={{ xs: 12, sm: 12, md: 3 }} flexDirection="column" justifyContent="space-evenly">
          <img src={image} />
        </Grid>

        <Grid className="p-3" size={{ xs: 12, sm: 12, md: 9 }}>
          <div className="px-8">

            <Title text="phytoplasmen_title" variant="big" color="orange"></Title>

            <p className="paragraph">
              <Text variant="normal"
                text="phytoplasmen_1">
              </Text>
            </p>
            <p className="paragraph">
              <Text variant="normal"
                text="phytoplasmen_2">
              </Text>
            </p>
            <p className="paragraph">
              <Text variant="normal"
                text="phytoplasmen_3">
              </Text>
            </p>
          </div>

        </Grid>

      </Grid>

    </Container>
  );
}

export default Phytoplasma;
